import './styles/index.less';

import 'jquery-lazy';
import { WEBP_FEATURES, isWebpFeatureSupported } from "../../core/utils/utils";

import * as main from './sections/main';
import * as reviews from './sections/reviews';
import * as products from './sections/products';
import * as articles from './sections/articles';
import * as aboutUs from './sections/about-us';

export {
	main,
	reviews,
	products,
	articles,
	aboutUs
}

export function init() {
	initAnchors();
	initLazy();
	ensureWebpBackwardCompatibility();
}

function initAnchors() {
	$('[rel=anchor]').click(function() {
		const $target = $($(this).attr('href'));
        if ($target.length > 0) {
	        const top = $target.offset().top;
	        $('body,html').animate({scrollTop: top}, 600);
        }
    });
}

function initLazy() {
	/* jquery-lazy for some reason downloads images immediately for element if it's parent has display set to "none"
	*  (in mobile layout last slide in "top products" section has display "none" for example). That's why initially
	*  track only visible elements and then check after window resizing whether there are new ones */
	function getNotHiddenElements() {
		const $elements = $('.lazy-load:visible');
		$elements.removeClass('lazy-load');
		return $elements;
	}

	setTimeout(() => {
		window.lazyLoader = getNotHiddenElements().lazy({ chainable: false, autoDestroy: false });
	});

	$(window).resize(() => {
		const $elements = getNotHiddenElements();
		if ($elements.length) {
			window.lazyLoader.addItems($elements);
		}
	});
}

async function ensureWebpBackwardCompatibility() {
	const isSupported = await isWebpFeatureSupported(WEBP_FEATURES.LOSSY);

	if (!isSupported) {
		// Find all elements marked as having webp background images and add class which can be used in css to replace
		// those images by jpeg/png alternatives
		$('.webp-bg').addClass('webp-bg-fallback');
	}
}



// WEBPACK FOOTER //
// ./modules/landing/index.js